export default class CuratorOrganization {
  public curatorOrganizationID: number;
  public name: string;
  public logoURL: string;
  public countries: string[];
  public currency: string;

  constructor(
    curatorOrganizationID: number = -1,
    name: string = null,
    logoURL: string = null,
    countries: string[] = [],
    currency: string = null,
  ) {
    this.curatorOrganizationID = curatorOrganizationID;
    this.name = name;
    this.logoURL = logoURL;
    this.countries = countries;
    this.currency = currency;
  }

  static fromApi(apiObject) {
    return new CuratorOrganization(
      apiObject.id,
      apiObject.name,
      apiObject.logoUrl,
      apiObject.countries,
      apiObject.currency,
    );
  }
}
